module.exports = "/_next/static/images/DeliverPersonalization@2x-affb0c1543286fe70d19786e73dfa410.webp";